import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    status: 0,
    hookTime: new Date(),
  },
  actions: {
    changeStatus({ rootState }, { status }) {
      rootState.status = status;
      rootState.hookTime = new Date();
    },
  },
  mutations: {},
  getters: {
    status: (state) => state.status,
    hookTime: (state) => state.hookTime,
  },
});

export default store;
